import React from 'react';
import './style.css';
import HeroSection from  './HeroSection';
import HistorySection from "./HistorySection";
import ValuesSection from "./ValuesSection";
import WhyChooseUsSection from "./WhyChooseUsSection";
export default function WhoWeAre() {

  return (
    <React.Fragment>
      <HeroSection />
      <HistorySection />
      <ValuesSection />
      <WhyChooseUsSection />
    </React.Fragment>
  );
}
